import anime from "animejs";

/**
 * Creates a zoom-in animation for tension mode.
 * Smoothly scales the container from 1.0 to the target scale over the given duration.
 * The easing accelerates so the zoom reaches peak as the final tension reel stops.
 *
 * @param {Object} target - PixiJS Container to animate (its .scale property)
 * @param {number} duration - Total zoom duration in ms (tensionReelCount × tensionCycleDuration)
 * @param {number} [maxScale=1.05] - Peak zoom scale
 * @returns {Object} animejs animation instance
 */
export const createTensionZoomAnimation = (
  target,
  duration,
  maxScale = 1.175,
) => {
  if (!target || !duration) return null;

  // Ensure we start from 1.0
  target.scale.x = 1.0;
  target.scale.y = 1.0;

  return anime({
    targets: target.scale,
    x: maxScale,
    y: maxScale,
    duration: duration,
    easing: "easeInOutQuad",
  });
};
